import { useState } from "react";
import { IChatLauncherContext } from "@/src/shared/ChatLauncher/ChatLauncherContext";

export default function ChatLauncherViewModel(): IChatLauncherContext {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen(!isOpen);

  return {
    isOpen,
    open,
    close,
    toggle
  };
}
